// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import NestedFormController from "stimulus-rails-nested-form"

import CustomNestedFormController from "./custom_nested_form_controller"
application.register("custom-nested-form", CustomNestedFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import LoginController from "./login_controller"
application.register("login", LoginController)
